import { ConversationEmptyState } from '@neo/blocks/ai-elements/conversation'
import { Suggestion, Suggestions } from '@neo/blocks/ai-elements/suggestion'
import { ShortcutKey } from '@neo/shared/components/shortcut-key'
import type { BuddySuggestion } from '../utils'

interface AssistantEmptyStateProps {
  suggestions: BuddySuggestion[]
  onSuggestionClick: (suggestion: string) => void
}

export const AssistantEmptyState = ({
  suggestions,
  onSuggestionClick,
}: AssistantEmptyStateProps) => (
  <ConversationEmptyState
    title="Ask Buddy"
    description="Hi, I'm Buddy! Ask me anything about Plivo products and services"
  >
    <div className="flex flex-col items-center">
      <img
        src="/img/buddy_prof.webp"
        alt="Buddy profile"
        className="h-28 w-28 object-cover animate-float"
      />
      <div className="h-4 w-20 rounded-[50%] bg-black/25 blur-[6px] -mt-3" />
    </div>
    <div className="flex flex-col items-center justify-center w-full pt-2">
      <p className="text-h3-500 pb-2">Hi, I&apos;m Buddy!</p>
      <p className="text-s-400 text-muted-foreground">
        Ask me anything about Plivo products and services.
      </p>
      <p className="text-xs-400 text-tertiary flex items-center gap-1 mt-1">
        Tip: You can open and close Buddy with{' '}
        <ShortcutKey shortcut={{ meta: true, shift: false, key: 'I' }} />
      </p>
    </div>
    <Suggestions className="max-w-[280px] items-center mt-4">
      {suggestions.map((suggestion) => (
        <Suggestion
          className="rounded-md w-fit font-inter text-s-400 normal-case tracking-normal"
          key={suggestion.testId}
          suggestion={suggestion.text}
          onClick={onSuggestionClick}
          data-testid={suggestion.testId}
        />
      ))}
    </Suggestions>
  </ConversationEmptyState>
)
